import { render, staticRenderFns } from "./AiBadge.vue?vue&type=template&id=26e2f802&scoped=true"
import script from "./AiBadge.vue?vue&type=script&lang=js"
export * from "./AiBadge.vue?vue&type=script&lang=js"
import style0 from "./AiBadge.vue?vue&type=style&index=0&id=26e2f802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e2f802",
  null
  
)

export default component.exports